<template>
  <div class="align-items-center justify-content-center activityPopup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="activity-button box">
          <div class="info-window">
            <div class="icon"></div>
            <div class="header"></div>
            <div class="info-content">

              <p class="title">HIER GAAN WE DAN!</p>
              <p class="countdownText">{{ countdownText }}</p>
            </div>
            <div class="footer"></div>


          </div>

        </div>
      </transition>

    </div>
  </div>


</template>

<script>

export default {
  name: "ActivityCountdown",
  components: {},
  props: {
    open: Boolean,
  },
  watch: {
    open: {
      handler()
      {
        if (this.open)
        {
          this.startCountdown();
        }
      },
      deep: true,
    },
  },
  data()
  {
    return {
      show: this.open,
      secondsLeft: 0,

    }
  },
  computed: {

    countdownText()
    {
      if (this.secondsLeft > 0)
      {
        return this.secondsLeft + "...";
      }
      else
      {
        return "Start!";
      }
    }

  },
  mixins: [],
  methods: {
    startCountdown()
    {
      this.secondsLeft = 3;
      let interval = setInterval(() =>
      {
        if (this.secondsLeft > 0)
        {
          this.secondsLeft -= 1;
        }
        else
        {
          clearInterval(interval);
        }
      }, 1000);
    }
  },
  mounted()
  {

  },
  created()
  {
  },
}


</script>

<style lang="scss" scoped>

.activityPopup {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;

  .popup-container {
    width: min(70vw, 70vh);
    height: min(70vw, 70vh);
  }

}

.activity-button {
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10%;
  position: relative;
}

.info-window {
  width: 100%;
  position: relative;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    height: min(5vw, 11vh);
    top: 1px;
    position: relative;
  }

  .info-content {
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px 50px;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    height: min(5vw, 11vh);
  }

}

.close-button {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 2%;
  top: 2%;
  background-image: url("~@/assets/image/button/bb_button_close.svg");
}

.title {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  text-align: center;
  //margin-top: -270px;
}

.countdownText {
  font-size: 3rem;
  font-weight: bold;
  color: white;
  text-align: center;
}

.icon {
  width: 100%;
  position: relative;
  top: 45px;
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 100%;
  height: 270px;
  z-index: -1;
  background-image: url("~@/assets/image/platform/visuals/activiteit_starten.png");
}

.first {
  margin-bottom: 15px;
}

.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.button-row {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

</style>